import React from 'react';
import { AlertBanner } from '@spark';

const ProjectCreatedBar = ({
    visible,
    projectName,
    taskName,
    onClose,
    onStartTaskSteps,
    onViewProject,
    isProjectCreation,
    actionButtonLabel,
}) => {
    const message = isProjectCreation
        ? (<span><b>{projectName}</b> was added to your Projects.</span>)
        : taskName
            ? (<span><b>{taskName}</b> was added to the <b>{projectName}</b> project.</span>)
            : (<span><b>{projectName}</b> was added to your Projects.</span>);

    const buttonLabel = actionButtonLabel
        || (isProjectCreation ? 'View Project' : 'Start Task Steps');

    if (!visible) return null;

    return (
        <div style={{ position: 'fixed', left: 0, width: '100%', zIndex: 1100, top: 60 }}>
            <AlertBanner
                feedback="success"
                text={message}
                buttonType="text"
                showButton={true}
                buttonLabel={buttonLabel}
                onActionClick={isProjectCreation ? onViewProject : onStartTaskSteps}
                showCloseButton={true}
                onCloseClick={onClose}
            />
        </div>
    );
};

export default ProjectCreatedBar;
